import { StepConfig } from '@/types/partnerConfig'

const welcomeStep: StepConfig = {
  slug: 'welcome',
  component: 'welcome',
}

const registrationStep: StepConfig = {
  slug: 'registration',
  component: 'registration',
}

const aboutYouStep: StepConfig = {
  slug: 'about-you',
  component: 'aboutYou',
}

const familyStep: StepConfig = {
  slug: 'family',
  component: 'family',
}

const summaryStep: StepConfig = {
  slug: 'thank-you',
  component: 'summary',
}

const eligibilityStep: StepConfig = {
  slug: 'eligibility',
  component: 'eligibility',
}

const premadeSteps: StepConfig[] = [
  welcomeStep,
  registrationStep,
  familyStep,
  summaryStep,
]

const premadeStepsWithoutFamily: StepConfig[] = [
  welcomeStep,
  registrationStep,
  summaryStep,
]

export default premadeSteps
export {
  welcomeStep,
  registrationStep,
  aboutYouStep,
  familyStep,
  summaryStep,
  eligibilityStep,
  premadeStepsWithoutFamily,
}
